import {
  AudienceSection,
  CustomSolutions,
  Features,
  Hero,
  KhagCompliance,
  LandingCta,
  LandingFooter,
  LandingNav,
  PricingSection,
  TermsNote,
} from '@/components/landing';

const Landing = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Skip-to-Content (WCAG 2.1) */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[100] focus:bg-card focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-sm focus:font-medium"
      >
        Zum Inhalt springen
      </a>
      {/* Top accent bar */}
      <div className="h-1 bg-gradient-to-r from-primary via-primary/70 to-primary" />
      {/* Nav */}
      <LandingNav />

      {/* Hero */}
      <Hero />

      {/* Zielgruppen */}
      <AudienceSection />

      {/* Features */}
      <Features />

      {/* Produktgrenze */}
      <KhagCompliance />

      {/* Individuelle Anpassungen Section */}
      <CustomSolutions />

      {/* Pricing Section */}
      <PricingSection />

      {/* CTA */}
      <LandingCta />

      {/* Widerrufsrecht & AGB Hinweis */}
      <TermsNote />

      {/* Footer */}
      <LandingFooter />
    </div>
  );
};

export default Landing;
